module.exports = __webpack_public_path__ + "img/gold-phone-case.ba6025d0.jpg";